import { createServerFn } from "@tanstack/react-start"
import { z } from "zod"
import { requireInventoryUserId } from "@/inventory/lib/auth.server"
import {
  createSupplyVendor,
  listSupplyVendors,
  updateSupplyVendor,
} from "../lib/vendors.server"

export const listSupplyVendorsFn = createServerFn({ method: "GET" })
  .validator((data?: { includeInactive?: boolean }) => data)
  .handler(async ({ data }) => {
    await requireInventoryUserId()
    return listSupplyVendors(data)
  })

export const createSupplyVendorFn = createServerFn({ method: "POST" })
  .validator((data: unknown) => z.object({ name: z.string() }).parse(data))
  .handler(async ({ data }) => {
    await requireInventoryUserId()
    return createSupplyVendor(data.name)
  })

export const updateSupplyVendorFn = createServerFn({ method: "POST" })
  .validator((data: unknown) =>
    z
      .object({
        id: z.number(),
        name: z.string().optional(),
        isActive: z.boolean().optional(),
      })
      .parse(data),
  )
  .handler(async ({ data }) => {
    await requireInventoryUserId()
    return updateSupplyVendor(data)
  })
